// This file is generated using misc/gen-item-icon-import.js
import ammoImg from '../assets/icons/ammo.png'
import bauxiteImg from '../assets/icons/bauxite.png'
import bucketImg from '../assets/icons/bucket.png'
import coinLargeImg from '../assets/icons/coin-large.png'
import coinMediumImg from '../assets/icons/coin-medium.png'
import coinSmallImg from '../assets/icons/coin-small.png'
import devMatImg from '../assets/icons/dev-mat.png'
import dlcImg from '../assets/icons/dlc.png'
import fuelImg from '../assets/icons/fuel.png'
import instantBuildImg from '../assets/icons/instant-build.png'
import ringImg from '../assets/icons/ring.png'
import screwImg from '../assets/icons/screw.png'
import steelImg from '../assets/icons/steel.png'

const imgMap = new Map([
  ['ammo', ammoImg],
  ['bauxite', bauxiteImg],
  ['bucket', bucketImg],
  ['coin-large', coinLargeImg],
  ['coin-medium', coinMediumImg],
  ['coin-small', coinSmallImg],
  ['dev-mat', devMatImg],
  ['dlc', dlcImg],
  ['fuel', fuelImg],
  ['instant-build', instantBuildImg],
  ['ring', ringImg],
  ['screw', screwImg],
  ['steel', steelImg],
])

export {imgMap}



// WEBPACK FOOTER //
// ./src/ui/item-icon-import.js